/**
 * @file src/audio/gainStageParams.js
 * @description The two USER gain stages, named once: the input trim ahead of processing and the
 * premix fader after it. The gain rail draws one of them at a time on a shared dB axis.
 *
 * Its own module (no audio-stack imports) so every consumer can share the one identity without
 * pulling in the audio engine — the same reason `syncBpmDisplaySource.js` exists. Before this the
 * pair was declared three times (root-param hydration, the engine adapter, the room client), which
 * is how one of them ended up routed through a room while the other silently was not.
 *
 * `premix-deck-i` and `input-gain-deck-i` are also PERSISTED parameter ids and MIDI-mapping keys —
 * renaming either breaks saved orbiters and learned CCs.
 */

/** The input trim, ahead of the processing chain. */
export const INPUT_GAIN_PARAM = 'input-gain-deck-i';

/** The premix fader, after the processing chain. */
export const PREMIX_PARAM = 'premix-deck-i';

/** Both stages, in signal order (input first) — the order the rail's IN | OUT switch offers them. */
export const GAIN_STAGE_PARAMS = Object.freeze([INPUT_GAIN_PARAM, PREMIX_PARAM]);
